import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import useGlobalStyles from '../../../styles';
import useStyles from '../../../styles/tags';
import { sensorTypeDetails } from '../../../utils/sensorProperties';
import { getLocationsById, getSensorsById } from '../../../state/selectors';
import { useAppSelector } from '../../../state/store';
import SensorIcon from '../../../styles/icons/SensorIcon';

interface SensorListItemProps {
  sensorId: string;
  handleTagging: (value: string) => void;
}

function SensorListItem({ sensorId, handleTagging }: SensorListItemProps) {
  const globalClasses = useGlobalStyles();
  const classes = useStyles();
  const locationsById = useAppSelector(getLocationsById);
  const sensorsById = useAppSelector(getSensorsById);
  const [hoveredId, setHoveredId] = useState('');

  const sensorDetail = sensorsById.get(sensorId);
  const Icon = sensorDetail?.type
    ? sensorTypeDetails[sensorDetail.type]?.icon ?? SensorIcon
    : SensorIcon;

  return (
    <ListItem
      className={globalClasses.compareListItem}
      onClick={() => handleTagging(sensorId)}
      onMouseEnter={() => setHoveredId(sensorId)}
      onMouseLeave={() => setHoveredId('')}
    >
      <Grid container key={sensorId} sx={{ alignItems: 'center' }}>
        <Grid item sm={5} sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <Icon />
          <Typography variant="body1" style={{ marginLeft: '5px' }}>
            {sensorDetail?.name ?? sensorId}
          </Typography>
        </Grid>
        <Grid item sm={3}>
          {locationsById.get(sensorDetail?.location ?? '')?.name}
        </Grid>
        <Grid item sm={4}>
          {hoveredId === sensorId && <span className={classes.tagPill}>Click to select</span>}
        </Grid>
      </Grid>
    </ListItem>
  );
}

export default SensorListItem;
